import { Address } from './../../../shared/interface/address';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL } from '@elevate-workspace/auth';
import { Observable } from 'rxjs';
import {  AddressResponse } from '../../../shared/interface/address';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  _httpClient=inject(HttpClient);
  _base_url=inject(BASE_URL);


  getlogedaddress():Observable<AddressResponse>{
    return this._httpClient.get<AddressResponse>(this._base_url + 'api/v1/addresses');
  }
  addaddress(data:Address):Observable<Address>{
    return this._httpClient.patch<Address>(this._base_url + 'api/v1/addresses', data);
  }

  updateaddress(data:Address,id:string):Observable<Address>{
    return this._httpClient.patch<Address>(this._base_url + `api/v1/addresses/${id}`, data);
  }
  removeaddress(id:string):Observable<Address>{
    return this._httpClient.delete<Address>(this._base_url + `api/v1/addresses/${id}`);
  }

}
